export default __webpack_public_path__ + "static/media/Dife.9165ddad.svg";